import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VCol,
        { attrs: { cols: "12" } },
        [_c("app-title", { attrs: { texto: "RESULTADOS" } })],
        1
      ),
      _c(
        VCol,
        [
          _c(
            VCard,
            { staticClass: "pa-2", attrs: { flat: "", outlined: "" } },
            [
              _c(
                VCardText,
                [
                  _c(VDataTable, {
                    staticClass: "elevation-0",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.perfis,
                      "item-key": "siape",
                      "items-per-page": 10,
                      search: _vm.opcoes.pesquisa,
                      "sort-by": _vm.opcoes.ordenarPor,
                      "sort-desc": _vm.opcoes.decrescente,
                      "no-data-text":
                        "Nenhum perfil encontrado para o(s) filtro(s) escolhido(s).",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.numero`,
                          fn: function ({ index }) {
                            return [_vm._v(" " + _vm._s(index + 1) + " ")]
                          },
                        },
                        {
                          key: `item.perfil`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                    color: "secondary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openDialogPerfil(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v(
                                                    "perm_contact_calendar"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v("Clique para visualizar o perfil"),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "top",
                          fn: function () {
                            return [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("app-sort", {
                                        model: {
                                          value: _vm.opcoes,
                                          callback: function ($$v) {
                                            _vm.opcoes = $$v
                                          },
                                          expression: "opcoes",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(VCol, {
                                    attrs: { cols: "0", md: "4" },
                                  }),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("app-search", {
                                        model: {
                                          value: _vm.opcoes,
                                          callback: function ($$v) {
                                            _vm.opcoes = $$v
                                          },
                                          expression: "opcoes",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-perfil", { attrs: { "dialog-props": _vm.dialogPerfilProps } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }